/**
 * Developers Page
 * Code examples and integration guides
 */

import { DeveloperSection } from '@/components/sections/developer';
import { HowItWorksSection } from '@/components/sections/how-it-works';
import { CtaSection } from '@/components/sections/cta';

export function DevelopersPage() {
  return (
    <>
      <div className="pt-24">
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Developer Documentation</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Get started with Naivana in minutes. Drop-in replacement for OpenAI SDK with intelligent routing built-in.
          </p>
        </div>
      </div>
      <DeveloperSection />
      <HowItWorksSection />
      <CtaSection />
    </>
  );
}
